import { Injectable } from '@angular/core';
import { LocaleConfig } from 'ngx-daterangepicker-material';

@Injectable({
  providedIn: 'root'
})
export class DateLocaleService {

  public locale: LocaleConfig = {
    format: 'YYYY-MM-DD',
    separator: ' - ',
    applyLabel: 'Применить',
    cancelLabel: 'Отмена',
    customRangeLabel: 'Выбрать диапазон',
    weekLabel: 'Н',
    daysOfWeek: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
    monthNames: [
      'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
      'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
    ],
    firstDay: 1
  };
}
